import log from '@alife/im-common-log';

// 只接受string类型
export default log;

function getKey() {
  let key = '/sc.ma.log';
  const pathname = window.location.pathname;

  if (pathname.indexOf('messenger.htm') !== -1) {
    key = '/sc.ma.messenger';
  }
  if (pathname.indexOf('weblite.htm') !== -1) {
    key = '/sc.ma.weblite';
  }
  return key;
}

// 内部打点方法
export function _log(ext) {
  window['goldlog'].record(getKey(), 'CLK', `${window.dmtrack_pageid ? `st_page_id=${window.dmtrack_pageid}&` : ''}ext=${encodeURIComponent(ext)}`, 'GET');
}
